import {assertAndContinue} from 'Asserts';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';
import {assertNever} from 'util/Types';

import {NoteLinkedGroupKind} from '../NoteLinkedGroupConstants';

export default function groupKindToIcon(kind: NoteLinkedGroupKind): BenchlingIconName {
  switch (kind) {
    case NoteLinkedGroupKind.ANALYSIS_TEMPLATE_GROUP:
      return FolderItemIcon.Flask;
    case NoteLinkedGroupKind.MIXTURE_GROUP:
      return FolderItemIcon.Mixture;
    case NoteLinkedGroupKind.NOTE_PART_GRID:
      return 'image';
    case NoteLinkedGroupKind.STOICHIOMETRY_GROUP:
      return FolderItemIcon.Reaction;

    default:
      assertAndContinue(false, `Unexpected group kind "${assertNever(kind)}"`);
      return 'asterisk';
  }
}
